












import { Component, Vue } from "vue-property-decorator";

@Component({
  props: {
    breadcrumbText: String
  }
})
export default class Breadcrumb extends Vue {}
